import axios from "axios"
import * as actionTypes from "./actionTypes";
 export const authStart =()=>{
     return {
    type : actionTypes.AUTH_START 
 }
}
export const authSuccess =(token , userId)=>{
    return {
   type : actionTypes.AUTH_SUCCESS ,
   idToken :token,
   userId : userId 
}
}
export const authfail =(error)=>{
    return {
   type : actionTypes.AUTH_FAIL ,
   error: error
}
}
export const logOut=()=>{
    localStorage.removeItem("token");
    localStorage.removeItem("expirationDate");
    localStorage.removeItem("userId") 
    return {
        type:actionTypes.LOG_OUT
    }
}
export const timeOut=(timeSkip)=>{
    return dispatch=>{
    setTimeout(()=>{
       dispatch(logOut());
    },timeSkip * 1000)
}
}
export const auth =(email , password , isSignUp)=>{
    return dispatch =>{
        dispatch(authStart());
        const authData = {
            email:email,
            password:password,
            returnSecureToken:true
        }
           let url = "https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyBh2hdxptiU3wy-XAYcsDHmEjoA5529Ftc";
         if (!isSignUp){
           url = "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBh2hdxptiU3wy-XAYcsDHmEjoA5529Ftc";
     
         }
        axios.post (url , authData)
      .then(response=>{
         console.log(response)
         const expirationDate = new Date( new Date().getTime() + response.data.expiresIn * 1000)
         localStorage.setItem("token" , response.data.idToken)
         localStorage.setItem("expirationDate" , expirationDate)
         localStorage.setItem("userId" , response.data.localId)
         dispatch(authSuccess(response.data.idToken , response.data.localId ))   
         dispatch(timeOut(response.data.expiresIn))
        })

      .catch(err=>{
    
          dispatch(authfail(err.response.data.error))
          
      })
    }
}

export const AuthRedirect=(path)=>{
return {
    type : actionTypes.AUTH_REDIRECT,
 path: path
}
}

export  const authCheckState=()=>{
     return dispatch=>{
         const token = localStorage.getItem("token");
         if (!token){
             dispatch(logOut())

         }else{
             const expirationDate = localStorage.getItem("expirationDate")
             if (expirationDate <= new Date())   {
                 dispatch(logOut())
             } else{
                 const userId = localStorage.getItem("userId")
                 dispatch(authSuccess(token , userId))
                 dispatch((timeOut(expirationDate.getTime() - new Date().getTime()))/1000)
             }
         }
     }
 }


// WEBPACK FOOTER //
// ./src/store/actions/Auth.js